<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.auName" style="width: 140px;" size="small" placeholder="请输入名称"
                        clearable></el-input>
                    <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="info" size="small" icon="el-icon-search" @click="IsSerch = true"
                        style="margin-left: 10px">更多搜索</el-button>
                    <el-dropdown size="small" split-button type="warning" style="margin-right: 10px;" @click="Out()"
                        @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增配件分类</el-button> -->

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="aubrId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
                        :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑配件分类' : '新增配件分类'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="配件分类" prop="afcName">
                                <el-input v-model="form.aahRepairTime" style="width: 50%;" placeholder="请输入名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 资产归还连同配件 -->
            <el-dialog title="归还资产" :visible.sync="ReturnZc" width="70%" top="15vh">
                <p>是否归还此用户所有领借物品</p>
                <el-radio-group v-model="hasFitting">
                    <el-radio :label="1">否</el-radio>
                    <el-radio :label="2">是</el-radio>
                </el-radio-group>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="ReturnZc = false">取 消</el-button>
                    <el-button type="primary" @click="sureReturnzc">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 筛选 -->
            <el-dialog title="更多搜索" :visible.sync="IsSerch" width="70%" top="8vh" :close-on-click-modal="false">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formDatas" :model="formDatas" label-position="left" label-width="100px"
                            @submit.native.prevent>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="姓名">
                                    <el-input v-model="formDatas.auName" style="width: 50%;" placeholder="请输入名称"></el-input>
                                </el-form-item>
                                <el-form-item label="物品名称">
                                    <el-input v-model="formDatas.aubrThisName" style="width: 50%;"
                                        placeholder="请输入名称"></el-input>
                                </el-form-item>
                                <el-form-item label="领用日期">
                                    <el-date-picker v-model="formDatas.aubrBorrowDateStart" type="date" value-format="yyyy-MM-dd"
                                        placeholder="选择开始日期" style="width: 45%;">
                                    </el-date-picker> -
                                    <el-date-picker v-model="formDatas.aubrBorrowDateEnd" type="date" value-format="yyyy-MM-dd"
                                        placeholder="选择结束日期"  style="width: 45%;">
                                    </el-date-picker>
                                </el-form-item>  
                            </div>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="物品类型">
                                    <el-select v-model="formDatas.aubrType" clearable placeholder="请选择"
                                        style="width: 130px">
                                        <el-option label="资产" :value="1" key="1"></el-option>
                                        <el-option label="配件" :value="2" key="2"></el-option>
                                        <el-option label="耗材" :value="3" key="3"></el-option>
                                        <el-option label="手机卡" :value="4" key="4"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="类型">
                                    <el-select v-model="formDatas.aubrBorrowReturn" clearable placeholder="请选择"
                                        style="width: 130px">
                                        <el-option label="领用" :value="1" key="1"></el-option>
                                        <el-option label="借用" :value="2" key="2"></el-option>
                                        <!-- <el-option label="归还" :value="3" key="3"></el-option> -->
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="归还时间">
                                    <el-date-picker v-model="formDatas.returntimeStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择开始日期"  style="width: 45%;">
                                    </el-date-picker> -
                                    <el-date-picker v-model="formDatas.returntimeEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择结束日期"  style="width: 45%;">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                            <el-form-item label="借用状态">
                                <el-select v-model="formDatas.aubrBorrowStatus" clearable placeholder="请选择"
                                    style="width: 130px">
                                    <el-option label="使用中" :value="1" key="1"></el-option>
                                    <el-option label="已归还" :value="2" key="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="partserch(), IsSerch = false"
                                    style="margin-left: 100px">立即搜索</el-button>
                                <el-button @click="closeSizer()" style="margin-left: 200px">取消</el-button>
                            </el-form-item>
                        </el-form>

                    </div>
                </div>
            </el-dialog>
            <!-- 编辑字段 -->
            <el-dialog title="编辑" :visible.sync="dbtrue" width="50%" top="8vh">
                <el-select v-model="dateUpdata" placeholder="请选择" filterable   v-if="TypeId == 2">
                    <el-option v-for="item in EditArr || []" :label="item.key" :value="item.value" :key="item.id">
                    </el-option>
                </el-select>
                <el-select v-if="TypeId == 3" v-model="dateUpdata" placeholder="请选择">
                    <el-option v-for="item in auNationArr || []" :label="item.snName" :value="item.snName" :key="item.snId">
                    </el-option>
                </el-select>

                <el-date-picker v-if="TypeId == 1" v-model="dateUpdata" type="date" value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
                <el-date-picker v-if="TypeId == 4" v-model="dateUpdata" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期">
                </el-date-picker>
                <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="CloseBreak">取 消</el-button> -->
                    <el-button type="primary" @click="sureDate">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
    
<script>

import { updateBorrowReturn, getAjUserBorrowReturnList, addAjFittingsClass, 
    updateAjFittingsClass, addAjUserReturn, updateAjAssetsHitch, addAjUserLoss, 
    exportBorrowReturn,getAjUserListOnJob 
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            aubrType:[{
                key:'领用',
                value:1,
                id:1
            },{
                key:'借',
                value:2,
                id:2
            },],
            userArr:[],
            dbtrue: false,
            dateUpdata: '',
            EditArr: [],
            TypeId: 0,

            hasFitting: '',
            ReturnZc: false,
            IsSerch: false,
            BreakDown: false,//处理故障
            dialog: false,
            edit: false,
            form: {
                aubrId: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",

                    title: "",
                    width: 40,
                    align: "center",
                    fixed: 'left',
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    align: "center",
                    fixed: 'left',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.auId, 'auId', rowIndex, row.aubrId, 2,this.userArr)}>{row.auName}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "部门",
                    align: "center",
                    fixed: 'left',
                    width: 160
                },
                {
                    field: "aubrThisName",
                    key: "aubrThisName",
                    title: "物品名称",
                    align: "center",
                    // fixed:'left',
                    width: 160
                },
                {
                    field: "aubrThisNumber",
                    key: "aubrThisNumber",
                    title: "物品编码",
                    align: "center",
                    // fixed:'left',
                    width: 100
                },
                {
                    field: "aubrThisNum",
                    key: "aubrThisNum",
                    title: "数量",
                    align: "center",
                    // fixed:'left',
                    width: 60
                },
                {
                    field: "aubrBorrowDate",
                    key: "aubrBorrowDate",
                    title: "领用日期",
                    align: "center",
                    // fixed:'left',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.aubrBorrowDate, 'aubrBorrowDate', rowIndex, row.aubrId, 1)}>{row.aubrBorrowDate}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "aubrType",
                    key: "aubrType",
                    title: "物品类型",
                    align: "center",
                    width: 80,
                    // fixed: 'left',
                    
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-tag type="primary"  >
                                    {row.aubrType == 1 ? '资产' : row.aubrType == 2 ? '配件' : row.aubrType == 3 ? '耗材' : '手机卡'}
                                </el-tag>

                            </span>
                        );
                    },
                },

                {
                    field: "aubrBorrowReturn",
                    key: "aubrBorrowReturn",
                    title: "类型",
                    align: "center",
                    width: 80,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.aubrBorrowReturn, 'aubrBorrowReturn', rowIndex, row.aubrId, 2,this.aubrType)}>
                                 {
                                    row.aubrBorrowReturn == 1 ? 
                                    <el-tag size="mini" type="danger"  > 领用 </el-tag> :  <el-tag size="mini" type="danger" > 借用 </el-tag> 
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "aubrBorrowStatus",
                    key: "aubrBorrowStatus",
                    title: "借用状态",
                    align: "center",
                    width: 80,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aubrBorrowStatus == 1 ? <el-tag size="mini" type="danger" > 使用中 </el-tag> : <el-tag size="mini" type="success" > 已归还 </el-tag>
                                }


                            </span>
                        );
                    },

                },
                { field: "aubrThisDes", key: "aubrThisDes", title: "备注", width: 140, align: "center", edit: true,},
                { field: "returntime", key: "returntime", title: "归还时间", width: 160, align: "center",
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.returntime, 'returntime', rowIndex, row.aubrId, 4)}>{row.returntime}</div>
                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 120,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {/* <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.handleEdit(row)}
                  >
                    处理
                  </el-button> */}
                                {
                                    row.aubrBorrowStatus == 1 ? <el-button

                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        归还
                                    </el-button> : <span></span>
                                }
                                {
                                    row.aubrType == 3 && row.aubrBorrowStatus == 1 ? <el-button

                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleSunhao(row)}
                                    >
                                        已损耗
                                    </el-button> : <span></span>
                                }

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                auName: '',
                aubrThisName: '',
                aubrType: '',
                aubrBorrowReturn: '',
                aubrBorrowStatus: '',
                dmDelete: 1,
                currentPage: 1,
                pageSize: 20,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAjUserListOnJob({checkStatus:2,currentPage:0}).then(res =>{
            res.data.forEach((item,index)=>{
                const s = {
                    value:item.auId,
                    key:item.auName,
                    id:item.auId,
                };
              this.userArr.push(s)  
            })
        })
        this.getList();
    },
    mounted() { },
    methods: {
        sureDate() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(this.dateKeys, this.dateUpdata);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aubrId = this.keysId
                    updateBorrowReturn(jsonObj).then(res => {
                        if (res.status == 200) {
                            this.$nextTick(() => {
                                console.log(this.tableData[this.dateIndexs], this.dateKeys);
                                this.tableData[this.dateIndexs][this.dateKeys] = this.dateUpdata
                            });
                            this.dbtrue = false;
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                            this.getList()
                        }

                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getdbtrue(val, key, index, id, typeid, Arr) {
            console.log("双击", val, key, index);
            this.dbtrue = true;
            this.dateUpdata = val;
            this.dateKeys = key;
            this.dateIndexs = index;
            this.keysId = id;
            this.TypeId = typeid;
            this.EditArr = Arr

        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out(command) {
            console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                exportBorrowReturn({ aubrIds: this.selectedRowKeysCollection.toString() }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });
                        this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = []

                    }
                })
            } else {
                this.openLoading()
                this.formDatas.exportType = 1
                exportBorrowReturn(this.formDatas).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            }
        },
        sureReturnzc() {
            this.$confirm("是否确定要归还吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    addAjUserReturn({ aubrId: this.aubrId, hasFitting: this.hasFitting }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "归还成功!",
                            });
                            this.ReturnZc = false;
                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleSunhao(row) {
            addAjUserLoss({ aubrId: row.aubrId }).then(res => {
                if (res.data) {
                    this.getList()
                    this.$message({
                        type: "success",
                        message: "处理成功!",
                    });
                }
            })
        },
        closeSizer() {
            this.formDatas = {
                auName: '',
                aubrThisName: '',
                aubrType: '',
                aubrBorrowReturn: '',
                aubrBorrowStatus: '',
                dmDelete: 1,
                currentPage: 1,
                pageSize: 20,
            };
            this.IsSerch = false;
            this.partserch()
        },
        // 处理故障
        CloseBreakDown() {
            this.BreakDown = false;

            this.$refs['formRef'].resetFields();
        },
        sureBreakDown() {
            this.$confirm("是否确定要处理故障吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjAssetsHitch(this.form).then(res => {
                        if (res.data) {
                            this.CloseBreakDown();
                            this.getList()
                            this.$message({
                                type: "success",
                                message: "处理成功!",
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        handleDelete(row) {
            if (row.aubrType == 1) {
                this.ReturnZc = true;
                this.aubrId = row.aubrId
                return
            }
            this.$confirm("是否确定要归还吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    addAjUserReturn({ aubrId: row.aubrId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "归还成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            this.form.aubrId = row.aubrId;
            this.BreakDown = true;
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjFittingsClass(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjFittingsClass(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aubrId = row.aubrId
                    console.log(jsonObj);
                    updateBorrowReturn(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.aubrId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.aubrId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.aubrId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.aubrId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.aubrId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjUserBorrowReturnList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjUserBorrowReturnList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjUserBorrowReturnList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>
    
<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
    